import _ from 'underscore';
import { AspectRatiosForDisplayAds } from '@bingads-webui-campaign-react/image-experience-model';

export const imageModelToViewModel = (imageModel) => {
  const type = /^Image(\d+)x(\d+)/.exec(imageModel.type);
  const width = parseInt(type[1], 10);
  const height = parseInt(type[2], 10);
  const image = {
    id: imageModel.id,
    disableEdit: imageModel.disableEdit,
    subType: 'DisplayCreativeImage',
    targetWidth: width,
    targetHeight: height,
    cropX: imageModel.cropSettings.SourceX,
    cropY: imageModel.cropSettings.SourceY,
    cropWidth: imageModel.cropSettings.SourceWidth,
    cropHeight: imageModel.cropSettings.SourceHeight,
    src: imageModel.src,
    text: imageModel.text,
    originalWidth: imageModel.width,
    originalHeight: imageModel.height,
  };

  return image;
};

export const imagePlacementsToImage = ({ crops, defaults, selected }) => {
  const filtered = crops.filter(({ type, width, height }) => {
    const aspectRatio = AspectRatiosForDisplayAds[type];
    const { minSize: [minWidth, minHeight] } = aspectRatio;
    return width >= minWidth && height >= minHeight;
  });

  let selectedImage = null;
  if (selected) {
    const selectedIndex = filtered.findIndex(({ type }) => type === `Image${selected.TargetWidth}x${selected.TargetHeight}`);
    filtered[selectedIndex].cropSettings = {
      ...filtered[selectedIndex].cropSettings,
      SourceWidth: selected.CropWidth,
      SourceHeight: selected.CropHeight,
      SourceX: selected.CropX,
      SourceY: selected.CropY,
    };
    selectedImage = filtered[selectedIndex];
  } else {
    selectedImage = _.max(filtered, ({ cropSettings: { SourceHeight, SourceWidth }, width, height }) => (SourceHeight * SourceWidth) / width / height);
  }

  return {
    data: {
      ...defaults,
      image: imageModelToViewModel(selectedImage),
      imagePlacements: filtered,
    },
  };
};

export const isAdsEmpty = ({
  displayAds,
}) => {
  if (displayAds.length === 1) {
    return displayAds[0].data && displayAds[0].data.image === null && displayAds[0].data.FinalUrls.length === 1 && displayAds[0].data.FinalUrls[0] === undefined;
  }

  return !(displayAds.length > 1);
};

export const addCreativesToDisplayAds = ({
  displayAds, creatives,
}) => {
  if (isAdsEmpty({ displayAds })) {
    // no ad exists, all ads are empty.
    return [...creatives];
  }

  return [...displayAds, ...creatives];
};

// recursivley translate all the keys and child keys first character to upper case for now
export const transformFirstCharacterToUpperCase = (creativeData = {}) => Object.keys(creativeData).reduce((acc, key) => {
  if (typeof creativeData[key] === 'object') {
    acc[key.charAt(0).toUpperCase() + key.slice(1)] = transformFirstCharacterToUpperCase(creativeData[key]);
  } else {
    acc[key.charAt(0).toUpperCase() + key.slice(1)] = creativeData[key];
  }
  return acc;
}, {});

